/**
 * Shared add-to-cart for the Vice City landing kit.
 *
 * Adds the line, re-renders the cart drawer and header from the same request
 * via Shopify's Section Rendering API, then opens Horizon's drawer. Falls back
 * to the cart page only if the theme has no drawer at all.
 *
 * Horizon's own cart-drawer-component auto-opens on shopify:cart:lines-update,
 * but only when it carries an `auto-open` attribute - it does not here - so the
 * drawer is opened explicitly rather than relying on that.
 */
(function () {
  if (window.vcnCart) return;

  var STANDARD_EVENTS = 'https://cdn.shopify.com/storefront/standard-events.js';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // The header's section id is generated per theme, so read it off the DOM
  // instead of hardcoding it.
  function sectionIds() {
    var ids = ['cart-drawer-section'];
    var header = document.querySelector('[id^="shopify-section-sections--"][id$="__header_section"]');
    if (header) ids.push(header.id.replace('shopify-section-', ''));
    return ids;
  }

  function swapSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (key) {
      var host = document.getElementById('shopify-section-' + key);
      var html = sections[key];
      if (!host || typeof html !== 'string') return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById('shopify-section-' + key);
      if (fresh) host.innerHTML = fresh.innerHTML;
    });
  }

  // Best effort only: keeps Shopify pixels and any installed apps in sync.
  // The constructor throws without a `promise`, so one is always supplied.
  function announce(variantId, qty) {
    import(STANDARD_EVENTS)
      .then(function (m) {
        document.dispatchEvent(
          new m.CartLinesUpdateEvent({
            action: 'add',
            source: 'vcn-landing',
            lines: [{ merchandiseId: Number(variantId), quantity: qty }],
            promise: Promise.resolve({ detail: { didError: false } }),
          })
        );
      })
      .catch(function () {
        /* analytics only - never block the sale on it */
      });
  }

  /**
   * Find the CART drawer specifically.
   *
   * With Shopify Inbox installed the page has TWO <theme-drawer> elements and
   * the chat one comes first in the DOM, so querySelector('theme-drawer')
   * opens an empty black chat panel instead of the cart. Always resolve it
   * through the cart component.
   */
  function cartDrawer() {
    var comp = document.querySelector('cart-drawer-component');
    var viaComp = comp && comp.closest('theme-drawer');
    if (viaComp) return viaComp;

    var all = Array.prototype.slice.call(document.querySelectorAll('theme-drawer'));
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('cart-drawer-component')) return all[i];
    }
    return null;
  }

  function openDrawer() {
    var drawer = cartDrawer();
    if (!drawer) return false;

    if (typeof drawer.open === 'function') {
      drawer.open();
      return true;
    }

    // Re-rendered markup can be in the DOM a tick before the custom element
    // upgrades; wait for the definition rather than falling through to /cart.
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('theme-drawer').then(function () {
        var d = cartDrawer();
        if (d && typeof d.open === 'function') d.open();
      });
      return true;
    }
    return false;
  }

  window.vcnCart = {
    add: function (variantId, qty) {
      var q = parseInt(qty, 10) || 1;
      if (!variantId) return Promise.reject(new Error('Missing variant'));

      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: q }],
          sections: sectionIds().join(','),
        }),
      })
        .then(function (r) {
          return r.json().then(function (body) {
            if (!r.ok) throw body;
            return body;
          });
        })
        .then(function (body) {
          swapSections(body.sections);
          announce(variantId, q);
          if (!openDrawer()) window.location.href = root() + 'cart';
          return body;
        });
    },

    /**
     * Wires a button to add-to-cart with a busy label and inline error.
     * @param {Object} opts - button, label, getQty, getVariant, error
     */
    bind: function (opts) {
      var btn = opts.button;
      if (!btn) return;
      var label = opts.label || btn;
      var idle = label.textContent;
      var busy = false;

      btn.addEventListener('click', function () {
        if (busy || btn.hasAttribute('disabled')) return;
        busy = true;
        if (opts.error) opts.error.classList.remove('is-on');
        label.textContent = 'Adding…';

        window.vcnCart
          .add(opts.getVariant(), opts.getQty())
          .then(function () {
            busy = false;
            label.textContent = idle;
          })
          .catch(function (e) {
            busy = false;
            label.textContent = idle;
            var msg = (e && (e.description || e.message)) || 'Could not add to cart. Please try again.';
            if (opts.error) {
              opts.error.textContent = msg;
              opts.error.classList.add('is-on');
            }
          });
      });
    },
  };
})();
